import useStyles from '../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import { useFormContext } from 'react-hook-form';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
  CalculationDeclarationContext,
  checkLogicalExpression,
} from '../../../../../services/common/CalculatorUtils';
import _ from 'lodash';
import EAIcon from '../../../../../components/common/EAIcon';
import clsx from 'clsx';
import i18next from 'i18next';
import { Box, Grid } from '@mui/material';
import Criteria from '../criteria/Criteria';
import CalculatorStandardInput from '../calculatorInputs/CalculatorStandardInput';
import ResultValueField from './ResultValueField';
import ColorPickerField from './ColorPickerField';

const StandardPresentation = ({ data, fieldName, index, onRemove, resultType, readOnly = false }) => {
  const { classes } = useStyles();

  const formMethods = useFormContext();
  const {
    setValue,
    trigger,
    setError,
    clearErrors,
    watch,
  } = formMethods;

  const {
    removeCallBack
  } = useContext(CalculationDeclarationContext);

  const [isOpen, setIsOpen] = useState(true);

  const flatCriteria = watch(`${fieldName}.flatCriteria`);

  useEffect(() => {
    if ((flatCriteria === undefined) || _.isEmpty(flatCriteria)) {
      clearErrors(`${fieldName}.formula`);
      onRemove();
    }
  }, [flatCriteria, onRemove, fieldName, clearErrors]);

  const validateLogicalExpression = useCallback((expr) => {
    return checkLogicalExpression(expr, formMethods.getValues(`${fieldName}.flatCriteria`));
  }, [formMethods, fieldName]);

  const onAddOrRemoveCriteriaEntry = useCallback(() => {
    trigger(`${fieldName}.formula`);
  }, [fieldName, trigger]);

  // Trigger formula validation when we have at least one criteria
  useEffect(() => {
    if(flatCriteria?.length > 0) {
      onAddOrRemoveCriteriaEntry(`${fieldName}.formula`);
    }
  }, [fieldName, flatCriteria, onAddOrRemoveCriteriaEntry])

  const onCriteriaOrderChange = useCallback(() => {
    setValue(`${fieldName}.formula`, ``);
    clearErrors(`${fieldName}.formula`);
  }, [fieldName, setValue, clearErrors]);

  const deleteBranch = useCallback(() => {
    flatCriteria?.forEach(criterion => removeCallBack(criterion.id));
    onRemove();
  }, [flatCriteria, onRemove, removeCallBack]);

  return (
    <div className={classes.rootBranch}>
      <div className={classes.branch} onClick={() => setIsOpen(!isOpen)}>
        <EAIcon icon="arrow/arrow-to-up_large" className={!isOpen ? classes.arrowIcon : classes.arrowIconReverse} />
        <div className={classes.branchNotice}>
          <span>Branche {index}</span>
        </div>

        <div className={classes.branchForm}>
          {!readOnly &&
            <div
              className={clsx(classes.declarationControlsLeft, classes.deleteCalc)}
              onClick={(e) => {
                e.preventDefault();
                deleteBranch();
              }}
            >
              <EAIcon icon="delete_red" style={{ width: "10px" }} />
              <span>{i18next.t("calculator.dialog.create.deleteBranch")}</span>
            </div>
          }
          <ResultValueField
            fieldName={`${fieldName}.resultValue`}
            resultType={resultType}
            disabled={readOnly}
          />
          <div style={{ position: "relative" }}>
            <ColorPickerField
              fieldName={`${fieldName}.resultColorCode`}
              defaultValue={data?.resultColorCode}
              disabled={readOnly}
            />
          </div>
        </div>
      </div>

      <div style={{ display: isOpen ? "block" : "none" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Criteria
              fieldName={`${fieldName}.flatCriteria`}
              connectiveOperator={<></>}
              onCriteriaOrderChange={onCriteriaOrderChange}
              readOnly={readOnly}
            />
          </Grid>

          <Grid item xs={12} margin={4}>
            <Box sx={{
              width: '718px',
              height: '83px',
              opacity: '0px',
              m: 0,
              p: 2,
              borderLeft: '2px solid #CC7B00',
              bgcolor: 'border-left: 2px solid #CC7B00',
              background: '#FFF7EB',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
            }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <div className={classes.branchFormulaLabel}>
                    <EAIcon icon={"warning-snack"} />
                    <span>{`${i18next.t("calculator.dialog.create.label.formula")} *`}</span>
                  </div>
                  <div className={classes.branchFormulaNotice}>
                    {`${i18next.t("calculator.dialog.create.label.formulaInfo")}`}
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <CalculatorStandardInput
                    fieldName={`${fieldName}.formula`}
                    label={``}
                    placeholder={`${i18next.t("calculator.dialog.create.label.formulaPlaceholder")}`}
                    isRequired={true}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(newValue) => { }}
                    disabled={readOnly}
                    validate={(value) => {
                      const errorMessage = validateLogicalExpression(value);

                      if (errorMessage === ``) {
                        clearErrors(`${fieldName}.formula`);
                        return null;
                      } else {
                        const message = i18next.t(`calculator.errors.${errorMessage}`);
                        setError(`${fieldName}.formula`, { type: "manual", message: message });
                        return message;
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default StandardPresentation;